import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, CanActivateChild } from '@angular/router';
import { Observable } from 'rxjs';
import { LocalStorageHelper } from '../helpers/local.storage.helper';
import { ROUTES_CONST } from '../constants/routes.constants';
import { AuthenticationServiceImpl } from '../http/impl/authentication.service.impl';
import { LOCAL_STORAGE_CONSTANTS } from '../constants/local.storage.constants';

@Injectable(
  {
    providedIn: 'root'
  }
)
export class AuthGuard implements CanActivate, CanActivateChild {

	constructor(
		@Inject(AuthenticationServiceImpl)
		public autenticationService: AuthenticationServiceImpl,
		public localStorageHelper: LocalStorageHelper,
		public router: Router
	) { }

	canActivate(next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
		let canActivate = this.autenticationService.isValidSession();
		if (state.url.includes('clase-zoom?key') || state.url.includes('dashboard-zoom?key')) {
			const { key } = state.root.queryParams
			let userOAuth = atob(key);
			userOAuth = userOAuth.replace(/[{}]/g, '');
			const properties = userOAuth.split(', ');
			const item: any = {}
			properties.forEach(el => {
				const keyValue = el.split(': ');
				item[keyValue[0]] = keyValue[0] !== 'email' ? Number(keyValue[1].trim().replace(/'/g, '')) : keyValue[1].trim().replace(/'/g, '');
			});
			const response = this.autenticationService.oAuthUser(item);
			if (typeof response === 'boolean') {
				canActivate = response;
			} else {
				response.subscribe({
					next: (token: any) => {
						token['oauth'] = true;
						if (state.url.includes('dashboard-zoom?key')) {
							delete token['oauth'];
							token['isTeacher'] = true;
						}
						this.autenticationService.saveToken(token);
					}, error: err => {
						// console.log('Error', err);
					}
				})
			}
		} else {
			if (!canActivate) {
				this.localStorageHelper.addItem(LOCAL_STORAGE_CONSTANTS.REDIRECT_URL, state.url);
				this.router.navigate([ROUTES_CONST.LOGIN.path]);
			}
			if (next.data.action) {
				const actionMenu = next.data.action;
				canActivate = this.autenticationService.hasAccess(actionMenu);
				if (!canActivate) {
					this.router.navigate([ROUTES_CONST.FORBIDDEN.path]);
				}
			}
		}
		return canActivate;
	}

	canActivateChild(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
		return this.canActivate(route, state);
	}
}
